module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "ack"
  }, [_c('span', {
    attrs: {
      "aria-label": "ix",
      "id": "page_ix",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('ol', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "textStyle2b center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', {
    staticClass: "textStyle2b center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/TitlePage#title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    staticClass: "textStyle2b center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    staticClass: "textStyle2b center"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/nav"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('li', {
    staticClass: "textStyle2b center",
    attrs: {
      "id": "link2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("INTRODUCTION"), _c('br'), _vm._v(" by Peter Quinn")])]), _vm._v(" "), _c('li', {
    staticClass: "textStyle2b center",
    attrs: {
      "id": "link3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Part01"
    }
  }, [_vm._v("PART ONE"), _c('br'), _vm._v(" To the Manor Borne")])]), _vm._v(" "), _c('li', {
    staticClass: "textStyle2b center",
    attrs: {
      "id": "link4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO"), _c('br'), _vm._v(" Malachy Ascending")])]), _vm._v(" "), _c('li', {
    staticClass: "textStyle2b center",
    attrs: {
      "id": "link5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART THREE"), _c('br'), _vm._v(" Dubious Luxuries")])]), _vm._v(" "), _c('li', {
    staticClass: "textStyle2b center",
    attrs: {
      "id": "link6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART FOUR"), _c('br'), _vm._v(" Whirled Affairs")])]), _vm._v(" "), _c('li', {
    staticClass: "textStyle2b center",
    attrs: {
      "id": "link7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART FIVE"), _c('br'), _vm._v(" Father to the Man")])]), _vm._v(" "), _c('li', {
    staticClass: "textStyle2b center",
    attrs: {
      "id": "link8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AFTERWORD")])]), _vm._v(" "), _c('li', {
    staticClass: "textStyle2b center",
    attrs: {
      "id": "link1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('li', {
    staticClass: "textStyle2b center",
    attrs: {
      "id": "link9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AboutAuthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    staticClass: "textStyle2b center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('div', [_c('span', {
    attrs: {
      "aria-label": "x",
      "id": "page_x",
      "role": "doc-pagebreak"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb74dd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/nav.vue
// module id = 75
// module chunks = 0